import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import MuiLink from "@mui/material/Link";
import classNames from "classnames";
import { useStyles } from "./styles";
export const Link = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    className,
    block,
    color = "primary",
    underline = "hover",
    variant = "inherit",
    ...otherProps
  } = props;
  const classes = useStyles(props);
  return /*#__PURE__*/React.createElement(MuiLink, _extends({
    ref: ref,
    className: classNames("prmbl-link-inner", classes.root, className),
    color: color,
    underline: underline,
    variant: variant
  }, otherProps));
});
Link.displayName = "Link";
Link.defaultProps = {
  underline: "hover",
  color: "primary",
  variant: "inherit"
};
export default Link;